
  <mat-form-field>
    <mat-label>Types</mat-label>
    <mat-select [formControl]="types" [multiple]="isMultiple" required>
      <!-- <mat-select-trigger>
        {{types.value?.[0] || ''}}
        <span *ngIf="(types.value?.length || 0) > 1" class="example-additional-selection">
          (+{{(types.value?.length || 0) - 1}} {{types.value?.length === 2 ? 'other' : 'others'}})
        </span>
      </mat-select-trigger> -->
      <mat-option *ngFor="let type of typeList" [value]="type">{{type}}</mat-option>
    </mat-select>
  </mat-form-field>


<button mat-raised-button color="primary" (click)="stopEditing()">Update Changes</button>
<button mat-raised-button color="primary" (click)="revertChanges()">Undo Changes</button>